import {IWidgetControllerConfig} from '@wix/native-components-infra/dist/src/types/types'
import {createFedopsLogger} from '../../commons/services/fedops'

export const createDetailsPageFedopsLogger = (controller: IWidgetControllerConfig) => {
  const config = controller.appParams.baseUrls.iframeUrl
    ? 'events-details-page-editor'
    : {
        appId: controller.appParams.appDefinitionId,
        widgetId: controller.type,
      }
  return createFedopsLogger(controller, config)
}
